import { CheckBoxProperties, useCheckBoxProperties } from "./CheckBoxProperties";
import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";

import { CheckBoxField } from "./CheckBoxField";
import { CheckBoxLabel } from "./CheckBoxLabel";
import { DraftCheckBoxComponent } from "./DraftCheckBoxComponent";
import { IControlAttributes } from "../../../../../base/models";
import { Registry } from "../../../../../base/register";
import { SimpleCheckBox } from "./SimpleCheckBox";

export const CheckboxComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useCheckBoxProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getCheckBox = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <CheckBoxField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleCheckBox
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <CheckBoxLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getCheckBox()}
    </CheckBoxLabel>
}

Registry.addControl({
    id: "108b73bb-e18d-410b-9861-09e49ed9fd77",
    name: "Checkbox",
    type: ControlType.Checkbox,
    properties: CheckBoxProperties,
    component: CheckboxComponent,
    draftComponent: DraftCheckBoxComponent,
})
